import React, { Component } from "react";
import _ from "i18n";
import { setSideBar, setSelectedComponent, initComponentAction } from "Actions";
import styles from "../SlideCompositionPage.local.scss";
import { connect } from "react-redux";
import Autocomplete from "../Autocomplete";
import SelectCategory from "../SelectCategory";
import AddIndicatorsExplanation from "./AddIndicatorsExplanation";
import InputsLanguages from "../../Common/InputsLanguages/InputsLanguages";

class BarometerConfiguration extends Component {
  handleChangeSideBar = (sideBar, selectedComponent) => {
    const { dispatch } = this.props;
    dispatch(setSideBar(sideBar));
    dispatch(initComponentAction());
    this.handleChangeSelectedComponent(selectedComponent);
  };
  handleChangeSelectedComponent = selectedComponent => {
    const { dispatch } = this.props;
    dispatch(setSelectedComponent(selectedComponent));
  };

  render() {
    const {
      componentConfig: { labels, indicators },
      selectedComponent,
      saving,
      fetching,
      componentConfig,
      componentAction
    } = this.props;
    return (
      <div>
        <div className={styles.config_text}>{_("componentConfig")}</div>
        <div style={{ marginTop: "15px" }}>
          <img
            src={`/img/slide-composition/component-image/${selectedComponent}`}
            alt={""}
            className={styles.component_config_img}
          />
        </div>
        <InputsLanguages
          handleChangeComponentLabels={this.props.HandleChangeComponentLabels}
          componentConfig={componentConfig}
        />
        <div>
          <div
            className={styles.labels_form_block}
            style={{ marginTop: "10px" }}
          >
            <div>
              <div className={styles.input_label}>
                {_("maxValue")} {"*"}
              </div>
              {this.props.update === "UPDATE" ? (
                <input
                  required
                  className={styles.input_text}
                  onChange={this.props.HandleMaxValue}
                  value={
                    componentConfig.config.maxValue &&
                    this.props.update === "UPDATE"
                      ? componentConfig.config.maxValue
                      : ""
                  }
                />
              ) : (
                <input
                  required
                  className={styles.input_text}
                  onChange={this.props.HandleMaxValue}
                />
              )}
              <div className={styles.input_label}>
                {_("minValue")} {"*"}
              </div>
              {this.props.update === "UPDATE" ? (
                <input
                  required
                  className={styles.input_text}
                  onChange={this.props.HandleMinValue}
                  value={
                    componentConfig.config.minValue &&
                    this.props.update === "UPDATE"
                      ? componentConfig.config.minValue
                      : ""
                  }
                />
              ) : (
                <input
                  required
                  className={styles.input_text}
                  onChange={this.props.HandleMinValue}
                />
              )}
            </div>
            <div className={styles.sample_component_config}>
              <div
                className={styles.select_label}
                style={{ marginLeft: "30px", marginTop: "20px" }}
              >
                {_("indicator")} {"*"}
              </div>
              <div>
                <Autocomplete
                  indicateurs={this.props.suggestions}
                  addComponentIndicator={this.props.HandleAddComponentIndicator}
                  indicatorNum={0}
                  indicatorUpdate={this.props.componentConfig.indicators}
                  addSlideIndicators={this.props.HandleAddSlideIndicator}
                  isSampleConfig={true}
                />
              </div>
              <div className={styles.category}>
                <div className={styles.select_category}>
                  {_("attacherAnnexeCategorie")}
                </div>
                <div style={{ marginTop: "10px" }}>
                  <SelectCategory
                    annexeCategories={this.props.annexeCategories}
                    HandleSelectAnnexeCategory={
                      this.props.HandleSelectAnnexeCategory
                    }
                    categoryUpdate={
                      this.props.componentConfig.config.annexeAttachmentCategory
                    }
                    isBarometer={true}
                    isTable={false}
                    isBarometerConfig={true}
                  />
                </div>
              </div>

              <AddIndicatorsExplanation
                explanation={this.props.explanation}
                handlerIndicatorsExplanation={
                  this.props.handlerIndicatorsExplanation
                }
                OpenIndicatorsExplanationModal={
                  this.props.OpenIndicatorsExplanationModal
                }
                isBarometerConfig={true}
                isTableConfig={false}
              />
            </div>
          </div>
          <div className={styles.actions_block}>
            <button
              style={{ marginRight: "5px" }}
              className={styles.btn_back}
              onClick={() => this.handleChangeSideBar("ComponentList", "")}
            >
              <img src="/img/icons/back.svg" alt={""} />
            </button>
            {componentAction === "ADD" ? (
              <button
                className={styles.btn_validate}
                onClick={() => this.props.HandleSaveComponentConfig()}
                disabled={
                  (labels["fr"].length === 0 &&
                    labels["en"].length === 0 &&
                    labels["nl"].length === 0) ||
                  indicators.length === 0
                }
              >
                <img
                  src={"/img/icons/tail-spin.svg"}
                  alt={""}
                  className={saving || fetching ? styles.loading : ""}
                />
                <span>{_("validate")}</span>
              </button>
            ) : (
              <button
                className={styles.btn_validate}
                onClick={() =>
                  this.props.handleUpdateComponent(this.props.selectedCase)
                }
              >
                <img
                  src={"/img/icons/tail-spin.svg"}
                  alt={""}
                  className={saving || fetching ? styles.loading : ""}
                />
                <span>{_("edit")}</span>
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  suggestions: state.indicators.suggestions.items,
  selectedComponent: state.slideComposition.composition.selectedComponent,
  selectedCase: state.slideComposition.composition.layout.selectedCase,
  slideId: state.slideComposition.slideId,
  saving: state.slideComposition.saving,
  fetching: state.slideComposition.fetchSlide.fetching,
  componentConfig: state.slideComposition.componentConfig,
  componentAction: state.slideComposition.ComponentAction,
  update: state.slideComposition.ComponentAction,
  annexeCategories: state.annexeCategorySuggestions.enabled
});

export default connect(mapStateToProps)(BarometerConfiguration);



// WEBPACK FOOTER //
// ./src/components/SlideComposition/ComponentConfiguration/BarometerConfiguration.js